import { ApolloClient, InMemoryCache, split, HttpLink, ApolloLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import store from 'redux/store';
import { setOutOfService } from 'redux/actions';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { setContext } from '@apollo/client/link/context';
import Cookies from 'js-cookie';

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_DEVELOPMENT==='development' ? `${process.env.REACT_APP_REMOTE_ENDPOINT}graphql`: '/graphql',
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((err) => {
      const code = err.extensions?.code;
      if (code === 'UNAUTHENTICATED') {
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    });
  }

  if (networkError) {
    store.dispatch(setOutOfService(true));
  }
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from cookie if it exists
  const token = Cookies.get('token') || ''
  const newHeaders = {...headers}
  if(token) {
    newHeaders.authorization = `Bearer ${token}`
  }
  // return the headers to the context so httpLink can read them
  return {
    headers: newHeaders
  }
});

const httpAuthErrorLink = ApolloLink.from([
  errorLink,
  authLink,
  httpLink
]);

const wsLink = new GraphQLWsLink(
  createClient({
    url: process.env.REACT_APP_WEBSOCKET_URL,
    connectionParams: () => {
      const token = Cookies.get('token') || '';
      return {
        authorization: token ? `Bearer ${token}` : '',
      };
    },
    on: {
      connected: (data) => console.log('[WS] connected'),
      closed: () => console.log('[WS] closed'),
      error: (err) => console.error('[WS] error', err),
    },
  })
);

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpAuthErrorLink
);

const cache = new InMemoryCache();

export const client = new ApolloClient({
  link: splitLink,
  cache: cache,
  devtools: {
    enabled: process.env.REACT_APP_DEVELOPMENT === 'development'
  }
});
